/* Firebelly homepage sections (fb-home-*). Claude build 2026-10-02.
   Scroll reveals, timeline and milestone lines, add to cart from the cards, tap-to-play videos.
   Loaded by every fb-home section, so it guards itself and runs once. */
(function () {
  if (window.fbHome) return;
  window.fbHome = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var animate = !reduce && !design && 'IntersectionObserver' in window;
  if (animate) document.documentElement.classList.add('fbh-anim');

  function observe(el, cb, opts) {
    if (!animate) { cb(el); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { cb(e.target); io.unobserve(e.target); } });
    }, opts || { rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }

  /* The hero fills the screen under the header, whatever the header's height */
  function sizeHero(root) {
    var hero = root.querySelector('.fbh-hero');
    if (!hero) return;
    var top = hero.getBoundingClientRect().top + window.scrollY;
    hero.style.setProperty('--fbh-top', Math.max(0, Math.round(top)) + 'px');
  }

  /* Cart: plus and minus on the cards talk to the real cart, then tell the theme to refresh its header and drawer */
  var cart = {}, busy = false, toastTimer;
  function toast(msg) {
    var t = document.querySelector('.fbh-toast');
    if (!t) { t = document.createElement('div'); t.className = 'fbh-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('fbh-show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('fbh-show'); }, 1600);
  }
  function paint() {
    document.querySelectorAll('.fbh-card[data-vid]').forEach(function (c) {
      var n = cart[c.dataset.vid] || 0, out = c.querySelector('output'), minus = c.querySelector('.fbh-minus');
      if (out) out.textContent = n;
      if (minus) minus.disabled = n === 0;
      c.classList.toggle('fbh-has', n > 0);
    });
  }
  function readCart(j) { cart = {}; (j.items || []).forEach(function (it) { cart[String(it.variant_id)] = (cart[String(it.variant_id)] || 0) + it.quantity; }); paint(); return j; }
  var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function loadCart() { fetch('/cart.js', { headers: H }).then(function (r) { return r.json(); }).then(readCart).catch(function () {}); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.fbh-step button');
    if (!b || busy) return;
    var card = b.closest('.fbh-card'), vid = card.dataset.vid, cur = cart[vid] || 0;
    var next = Math.max(0, cur + (b.classList.contains('fbh-plus') ? 1 : -1));
    if (next === cur) return;
    busy = true;
    var req = cur === 0
      ? fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js', { headers: H }); })
      : fetch('/cart/change.js', { method: 'POST', headers: H, body: JSON.stringify({ id: vid, quantity: next }) })
          .then(function (r) { if (!r.ok) throw new Error('change'); return r; });
    req.then(function (r) { return r.json(); }).then(function (j) {
      readCart(j);
      toast((next > cur ? 'Added ' : 'Removed ') + card.dataset.title);
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: j, sourceId: 'fb-home', data: { itemCount: j.item_count, source: 'fb-home' } } }));
    }).catch(function () { toast('Could not update your cart. Try again.'); })
      .finally(function () { busy = false; });
  });
  document.addEventListener('cart:update', function (e) { if (!e.detail || e.detail.sourceId !== 'fb-home') loadCart(); });

  /* Videos: nothing downloads until someone taps one; one plays at a time */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.fbh-vid');
    if (!card) return;
    var v = card.querySelector('video');
    if (!v) return;
    if (!v.getAttribute('src') && card.dataset.src) v.src = card.dataset.src;
    if (v.paused) {
      document.querySelectorAll('.fbh-vid video').forEach(function (o) { if (o !== v && !o.paused) { o.pause(); o.closest('.fbh-vid').classList.remove('fbh-on'); } });
      v.play(); card.classList.add('fbh-on');
    } else { v.pause(); card.classList.remove('fbh-on'); }
  });

  function init(root) {
    sizeHero(root);
    root.querySelectorAll('[data-fbh-rv]').forEach(function (el) { observe(el, function (x) { x.classList.add('fbh-in'); }); });
    root.querySelectorAll('.fbh-tl, .fbh-ms').forEach(function (el) {
      if (!animate) { el.classList.add('fbh-notrans'); }
      observe(el, function (x) { x.classList.add('fbh-go'); }, { threshold: 0.5 });
    });
    root.querySelectorAll('.fbh-routine').forEach(function (el) { observe(el, function (x) { x.classList.add('fbh-in'); }, { threshold: 0.3 }); });
    /* Touch screens: the bag turns into the loose leaf as the card scrolls in */
    if (window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.intersectionRatio > 0.7) { setTimeout(function () { e.target.classList.add('fbh-flip'); }, 600); io2.unobserve(e.target); } });
      }, { threshold: [0.7] });
      root.querySelectorAll('.fbh-card').forEach(function (c) { io2.observe(c); });
    }
    /* Phones: flavour and benefit become two tabs */
    var tabs = [].slice.call(root.querySelectorAll('[data-fbh-why]'));
    if (tabs.length) {
      var panels = [].slice.call(root.querySelectorAll('.fbh-why'));
      tabs[0].closest('.fbh').classList.add('fbh-tabs-on');
      if (panels[0]) panels[0].classList.add('fbh-on');
      tabs.forEach(function (b) {
        b.addEventListener('click', function () {
          tabs.forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
          panels.forEach(function (p, i) { var on = i === +b.dataset.fbhWhy; p.classList.toggle('fbh-on', on); if (on) p.classList.add('fbh-in'); });
        });
      });
    }
    /* Phones: the reviews become a row you swipe, and it moves on by itself every 3 seconds until someone touches it */
    if (window.matchMedia('(max-width: 860px)').matches) root.querySelectorAll('.fbh-rrow').forEach(function (row) {
      row.classList.add('fbh-swipe');
      if (!animate) return;
      var held = 0;
      row.addEventListener('touchstart', function () { held = Date.now(); }, { passive: true });
      setInterval(function () {
        if (Date.now() - held < 6000) return;
        var r = row.getBoundingClientRect();
        if (r.top > window.innerHeight || r.bottom < 0) return;
        var c = row.querySelector('.fbh-rv'), w = c ? c.getBoundingClientRect().width + 12 : 280;
        if (row.scrollLeft + row.clientWidth >= row.scrollWidth - 4) row.scrollTo({ left: 0, behavior: 'smooth' });
        else row.scrollBy({ left: w, behavior: 'smooth' });
      }, 3000);
    });
    /* The hero button scrolls to the next section when no link is set */
    var hb = root.querySelector('[data-fbh-next]');
    if (hb) hb.addEventListener('click', function (e) {
      var sec = hb.closest('.shopify-section');
      var next = sec && sec.nextElementSibling;
      if (next) { e.preventDefault(); next.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }
    });
  }

  function start() {
    document.querySelectorAll('.fbh').forEach(function (root) { init(root.closest('.shopify-section') || root); });
    loadCart();
    window.addEventListener('resize', function () { document.querySelectorAll('.fbh-hero').forEach(function (h) { sizeHero(h.parentNode); }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); loadCart(); });
})();
